// Предпочтительные архетипы и политики фракций (см. developer_artifacts/factions_rules.md)
import {FACTIONS} from "../../../constants/factions";
import {POLICIES} from "../../../constants/policies";
import {BOT_ARCHETYPES} from "./archetypes";
import {isPreW39FactionPlayer} from "../abTestGates";

const {
  AGGRESSIVE_RUSH,
  AGGRESSIVE_BUILDUP,
  DEFENSIVE,
  ECONOMIC_POINTS,
  ECONOMIC_COINS,
} = BOT_ARCHETYPES;

export const FACTION_PREFERENCES = {
  [FACTIONS.BEASTMEN]: {
    archetypes: [AGGRESSIVE_RUSH, AGGRESSIVE_BUILDUP],
    policies: [POLICIES.AGRARIANISM, POLICIES.DESPOTISM, POLICIES.MILITARISM, POLICIES.BARBARISM],
    antiPolicies: [
      POLICIES.PATRIOTISM, POLICIES.OLIGARCHY, POLICIES.SERVARIANISM,
      POLICIES.FORTIFICATIONISM, POLICIES.THEOCRACY,
    ],
  },
  [FACTIONS.DEMONS]: {
    archetypes: [AGGRESSIVE_BUILDUP, AGGRESSIVE_RUSH],
    policies: [
      POLICIES.TOTALITARIANISM, POLICIES.DESPOTISM, POLICIES.PATRIOTISM, POLICIES.MILITARISM,
      POLICIES.AGRARIANISM, POLICIES.HEGEMONISM, POLICIES.ECOANARCHISM,
    ],
    antiPolicies: [
      POLICIES.SERVARIANISM, POLICIES.FORTIFICATIONISM, POLICIES.THEOCRACY, POLICIES.OLIGARCHY,
    ],
  },
  [FACTIONS.DWARVES]: {
    archetypes: [DEFENSIVE, ECONOMIC_COINS],
    // SERVARIANISM — ядро стратегии; вторая половина игры: THEOCRACY (храмы)
    // или FANATICISM (руины, гейтится владением руинами)
    policies: [
      POLICIES.SERVARIANISM, POLICIES.THEOCRACY, POLICIES.FANATICISM,
      POLICIES.INDUSTRIALISM, POLICIES.DESPOTISM,
    ],
  },
  [FACTIONS.ELVES]: {
    // Защитная стратегия почти всю игру: медленный рост отрядов делает эльфов уязвимыми
    archetypes: [DEFENSIVE, AGGRESSIVE_BUILDUP],
    policies: [POLICIES.PATRIOTISM, POLICIES.AGRARIANISM, POLICIES.INDUSTRIALISM, POLICIES.ECOANARCHISM],
    antiPolicies: [POLICIES.HEGEMONISM, POLICIES.SERVARIANISM, POLICIES.OLIGARCHY],
  },
  [FACTIONS.ENLIGHTENED]: {
    archetypes: [DEFENSIVE, ECONOMIC_COINS],
    policies: [POLICIES.FANATICISM, POLICIES.OLIGARCHY, POLICIES.SERVARIANISM, POLICIES.INDUSTRIALISM],
  },
  [FACTIONS.HUMANS]: {
    archetypes: [AGGRESSIVE_BUILDUP, DEFENSIVE, ECONOMIC_POINTS, ECONOMIC_COINS],
    policies: [
      POLICIES.INDUSTRIALISM, POLICIES.AGRARIANISM, POLICIES.TOTALITARIANISM,
      POLICIES.OLIGARCHY, POLICIES.THEOCRACY, POLICIES.DESPOTISM,
    ],
  },
  [FACTIONS.INSECTOIDS]: {
    archetypes: [AGGRESSIVE_RUSH],
    // ВАРВАРСТВО во главе: +1 урона ближнего боя множится на массу роя —
    // с ним рой переходит в агрессивный d6-раш (нюанс живого теста 10)
    policies: [
      POLICIES.BARBARISM, POLICIES.ECOANARCHISM, POLICIES.TOTALITARIANISM,
      POLICIES.MILITARISM, POLICIES.DESPOTISM,
    ],
    // Антирекомендации: эти политики фракция не покупает никогда
    antiPolicies: [
      POLICIES.PATRIOTISM, POLICIES.OLIGARCHY, POLICIES.HEGEMONISM,
      POLICIES.SERVARIANISM, POLICIES.FORTIFICATIONISM,
    ],
  },
  [FACTIONS.LEPRECHAUNS]: {
    archetypes: [AGGRESSIVE_BUILDUP, DEFENSIVE],
    // ISOLATIONISM ситуативно бустится при потенциале кражи 3+; MILITARISM/BARBARISM —
    // бонусы ближнего боя для поздних захватов руин/великих рудников
    policies: [
      POLICIES.DESPOTISM, POLICIES.PATRIOTISM, POLICIES.SERVARIANISM, POLICIES.TOTALITARIANISM,
      POLICIES.ISOLATIONISM, POLICIES.MILITARISM, POLICIES.BARBARISM,
    ],
  },
  [FACTIONS.ORCS]: {
    archetypes: [AGGRESSIVE_RUSH, AGGRESSIVE_BUILDUP],
    policies: [
      POLICIES.BARBARISM, POLICIES.PATRIOTISM, POLICIES.DESPOTISM, POLICIES.MILITARISM,
      POLICIES.TOTALITARIANISM, POLICIES.ECOANARCHISM,
    ],
  },
  [FACTIONS.VENTORY]: {
    archetypes: [ECONOMIC_COINS, ECONOMIC_POINTS, DEFENSIVE],
    // FORTIFICATIONISM покупается только при угрозе (глобальный гейт)
    policies: [
      POLICIES.OLIGARCHY, POLICIES.INDUSTRIALISM, POLICIES.AGRARIANISM,
      POLICIES.THEOCRACY, POLICIES.FORTIFICATIONISM,
    ],
  },
  [FACTIONS.ELEMENTALS]: {
    archetypes: [ECONOMIC_POINTS, ECONOMIC_COINS, AGGRESSIVE_BUILDUP],
    // Доход монет в приоритете (строят больше всех); вторая половина: FANATICISM
    // при руинах, иначе THEOCRACY с храмами
    policies: [
      POLICIES.INDUSTRIALISM, POLICIES.THEOCRACY, POLICIES.FANATICISM,
      POLICIES.AGRARIANISM, POLICIES.OLIGARCHY,
    ],
  },
  [FACTIONS.RATMEN]: {
    archetypes: [AGGRESSIVE_RUSH],
    policies: [POLICIES.AGRARIANISM, POLICIES.ECOANARCHISM, POLICIES.MILITARISM, POLICIES.BARBARISM],
    antiPolicies: [
      POLICIES.PATRIOTISM, POLICIES.OLIGARCHY, POLICIES.THEOCRACY,
      POLICIES.SERVARIANISM, POLICIES.FORTIFICATIONISM,
    ],
  },
};

const DEFAULT_PREFERENCES = {
  archetypes: [AGGRESSIVE_BUILDUP, DEFENSIVE],
  policies: [POLICIES.INDUSTRIALISM, POLICIES.AGRARIANISM, POLICIES.TOTALITARIANISM],
};

// Волна 39: фракции, которые до волны были запрещены ботам. Порядок политик —
// из стратегий (developer_artifacts/bot_strategy/faction_strategy), данных
// симуляций по ним еще нет
export const W39_FACTION_PREFERENCES = {
  [FACTIONS.GIANTS]: {
    // Осторожная фракция: сила раскрывается после нескольких ходов снабжения
    archetypes: [DEFENSIVE, AGGRESSIVE_BUILDUP],
    policies: [
      POLICIES.OLIGARCHY, POLICIES.AGRARIANISM, POLICIES.TOTALITARIANISM, POLICIES.PATRIOTISM,
      POLICIES.SERVARIANISM, POLICIES.FORTIFICATIONISM,
    ],
    // Бесплатные d6 и бонус массе отрядов великанам не нужны: d6 им не нанять
    antiPolicies: [POLICIES.BARBARISM],
  },
  [FACTIONS.SUCCUBES]: {
    // Гибкая база, как у людей, с резервом монет на соблазнение
    archetypes: [AGGRESSIVE_BUILDUP, DEFENSIVE],
    policies: [
      POLICIES.PATRIOTISM, POLICIES.AGRARIANISM, POLICIES.OLIGARCHY, POLICIES.DESPOTISM,
      POLICIES.SERVARIANISM, POLICIES.FORTIFICATIONISM,
    ],
  },
  [FACTIONS.GOBLINS]: {
    // Оборонная фракция: гильдии и храмы, ловушки у своих городов
    archetypes: [DEFENSIVE, ECONOMIC_COINS],
    // Волна 41 (отчет 39): Варварство первым — бесплатные d6, урон и очки за убийства.
    // На гоблинов политики влияют сильнее способностей; прежний список с олигархией
    // первой был на 12 очков хуже
    policies: [
      POLICIES.BARBARISM, POLICIES.THEOCRACY, POLICIES.SERVARIANISM, POLICIES.FANATICISM,
      POLICIES.ECOANARCHISM, POLICIES.TOTALITARIANISM,
    ],
  },
};

// Волна 42 (отчет 41): ближний бой — сильная сторона фракции, варварство и милитаризм
// усиливают его и дают очки за него. Общий список был на 27 очков хуже
const W42_CELECTIALS_POLICIES = [
  POLICIES.BARBARISM, POLICIES.MILITARISM, POLICIES.TOTALITARIANISM, POLICIES.PATRIOTISM,
  POLICIES.DESPOTISM, POLICIES.ECOANARCHISM,
];

/**
 * Предпочтения фракции. playerId — для решений самого игрока: legacy-игрок
 * волны 39 (isPreW39FactionPlayer) за великанов, суккубов и гоблинов получает
 * прежние общие предпочтения. Без playerId (оценка соперника по его фракции) —
 * предпочтения фракции
 */
export const getFactionPreferences = (factionId, playerId, isStorm = false) => {
  if (factionId === FACTIONS.CELECTIALS) {
    return {
      // isStorm — бот золото и выше, см. checkIfW42CelectialsStormPlayer
      archetypes: isStorm ? [AGGRESSIVE_RUSH, AGGRESSIVE_BUILDUP] : DEFAULT_PREFERENCES.archetypes,
      policies: W42_CELECTIALS_POLICIES,
    };
  }
  if (W39_FACTION_PREFERENCES[factionId] && !(playerId !== undefined && isPreW39FactionPlayer(playerId))) {
    return W39_FACTION_PREFERENCES[factionId];
  }
  return FACTION_PREFERENCES[factionId] || DEFAULT_PREFERENCES;
};
